// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Cp-z","imageAndVideoCount":"Dp-z","imageAndVideoContainer":"Ep-z","viewAllReviews":"Fp-z"};